import { Pipe, PipeTransform, inject } from '@angular/core';

import { DateTimeHelper } from '@pages/office/shared/helpers/date-time.helper';
import { UtilityService } from '@core/services/utility.service';
import { OfficeFieldWebInputType, OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';

@Pipe({
  name: 'dateFromJson',
  standalone: true,
})
export class DateFromJsonPipe implements PipeTransform {
  private dateLookupTypes: string[] = [OfficeFieldWebInputTypeEnum.date, OfficeFieldWebInputTypeEnum.month];
  private utilityService = inject(UtilityService);

  transform(value: string, webInputType: OfficeFieldWebInputType, mask?: string): unknown {
    return this.dateLookupTypes.includes(webInputType) ? this.getFormattedValue(value, webInputType, mask) : value;
  }

  private getFormattedValue(value: string, webInputType: OfficeFieldWebInputType, mask?: string): string {
    const format =
      mask || (webInputType === OfficeFieldWebInputTypeEnum.month ? DateTimeHelper.MONTH_FORMAT : this.utilityService.getDateFormat());
    const date = DateTimeHelper.getJSDateFromString(value);
    return DateTimeHelper.getFormattedValue(date, format.toLocaleUpperCase());
  }
}
